import { render, staticRenderFns } from "./service-items-edit.vue?vue&type=template&id=7ef09d19&scoped=true&"
import script from "./service-items-edit.vue?vue&type=script&lang=ts&"
export * from "./service-items-edit.vue?vue&type=script&lang=ts&"
import style0 from "./service-items-edit.vue?vue&type=style&index=0&id=7ef09d19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef09d19",
  null
  
)

export default component.exports